<p-accordion>
  <p-accordionTab [(selected)]="!collapsed" header="{{ 'HOME.ACCUMULATOR_TITLE' | translate }}">
    <div class="tabbassiCard card">
      <div class="card-body">
        <p>
          {{ "HOME.ACCUMULATOR_DESC" | translate }}
        </p>
        <div class="row align-items-center mb-3">
          <div class="col-auto">{{ "RACES.TYPE_OF_BET" | translate }} :</div>
          <div class="col">
            <p-dropdown class="w-100" [options]="bets" [(ngModel)]="selectedBet" optionLabel="viewValue"></p-dropdown>
          </div>
        </div>

        <div class="row align-items-center">
          <div class="col-auto">{{ "RACES.STAKES" | translate }} :</div>
          <div class="col">
            <p-dropdown class="w-100" [options]="stakes" [(ngModel)]="selectedStakes" optionLabel="viewValue">
            </p-dropdown>
          </div>
        </div>
      </div>
      <button class="btn btn-success btn-block roudned-sm">{{ "GENERAL.DELETE" | translate }} </button>
    </div>
  </p-accordionTab>
</p-accordion>
